import {isEmpty} from 'lodash';
import {Http, URLSearchParams} from '@angular/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Currency} from '../../../clients/app/modules/+registration/api/dictionary/account-currency.service';

@Injectable()
export class CurrenciesService {

    constructor(private http: Http) {}

    private currencies: any[];
    private availableCurrencies: any[];

    getCurrencies(): Observable<any[]> {
        if (isEmpty(this.currencies)) {
            return this._getCurrencies(false)
                .map(currencies => {
                    this.currencies = currencies;
                    return this.currencies = currencies;
                });
        } else {
            return Observable.of(this.currencies);
        }
    }

    getAvailableCurrencies(): Observable<any[]> {
        if (isEmpty(this.availableCurrencies)) {
            return this._getCurrencies(true)
                .map(currencies => {
                    this.availableCurrencies = currencies;
                    return currencies;
                });
        } else {
            return Observable.of(this.availableCurrencies);
        }
    }

    private _getCurrencies(availableOnly: boolean): Observable<any[]> {
        return this.http.get('/api/client/dictionary/currencies', {search: this._buildSearchParam(availableOnly)})
            .map(response => response.json())
            .map(response => response.currencies);
    }

    private _buildSearchParam(availableOnly: boolean): URLSearchParams {
        let search: URLSearchParams = new URLSearchParams();
        search.set('available_only', String(availableOnly));
        return search;
    }

    getAppreciateCurrencies(): Observable<Currency[]> {
        return this.http.get('/api/client/dictionary/currencies?appreciate')
            .map(result => result.json())
            .map(result => result.currencies);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/api/dictionaries/currencies.service.ts